import { RIT } from '@groove-labs/groove-ui';
import { withStyles } from '@material-ui/core/styles';
import { toggleHotlist } from 'Modules/People/actions';
import FireEmptyIcon from 'Modules/People/components/FireEmptyIcon';
import FireIcon from 'Modules/People/components/FireIcon';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

const styles = {
  root: {
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
};

@withStyles(styles)
@connect(
  () => {
    return {};
  },
  {
    toggleHotlist,
  }
)
export default class HotlistButton extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    id: PropTypes.number.isRequired,
    hotlisted: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    toggleHotlist: PropTypes.func.isRequired,
  };

  render() {
    const { classes, id, hotlisted, email, toggleHotlist } = this.props;

    return (
      <button
        className={classes.root}
        onClick={e => {
          e.stopPropagation();
          toggleHotlist({ id, hotlisted, email });
        }}
      >
        {RIT(hotlisted, () => (
          <FireIcon />
        ))}
        {RIT(!hotlisted, () => (
          <FireEmptyIcon />
        ))}
      </button>
    );
  }
}
